// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// this is for <ConnectedLoader /> and nothing else

// A global loading icon which prevents the user from interacting with the page while it is active.

// NOTE - loading state is an int which represents the number of
// active, async operations which should display the loading icon.
// this way thunks which use other thunks which use the loadingToggler
// don't get weird. Think loading the page on a path details sheet from the
// project summary view. We need to fetch multiple settings, project data and
// path details data. Without this mechanism, once the first thunk hides the loader,
// the user will stare at a blank screen until the other operations are complete.
import loading from './reducer'
export default loading

export loadingToggler from './loadingToggler'
